import React, { Component } from 'react';
import PropTypes from 'prop-types';

import IconButton from 'material-ui/IconButton';
import noScroll from 'no-scroll';

import Modal from './Modal';
import FileIcon from './FileIcon';

class Attach extends Component {

    state = {
        loading: false,
        imageModalActive: false
    };

    static propTypes = {
        item: PropTypes.object,
        onClick: PropTypes.func
    }



    onClickHandler = () => {
        if (typeof this.props.onClick === 'function') {
            // e.preventDefault();
            this.props.onClick(this);
        }
        else{

            console.log(this.props.item.type)

            if(this.props.item.type.startsWith('image')){
                this.onOpenModal();
            }
            else{
                window.open(this.props.item.lg);
            }


        }
    }

    onOpenModal = () => {
        noScroll.on();
      this.setState({ imageModalActive: true });
    }

    onCloseModal = () => {
        noScroll.off();
      this.setState({ imageModalActive: false });
    }



    render() {

        const { item } = this.props;
        const { loading, imageModalActive } = this.state;

        return (
            <div className="attach" onClick={this.onClickHandler}>

                <div className="small">
                    <FileIcon item={item} thumb={item.sm} />
                </div>
                <span className="name">{item.name}</span>

                <Modal show={imageModalActive} onClose={this.onCloseModal}>
                    <img className="large" src={item.lg} alt="" />
                    <div className="panel">
                    </div>
                </Modal>


            </div>
        );

    };

}

export default Attach;


// WEBPACK FOOTER //
// ./src/modules/notes/Attach.js